import { ChoiceOptionModel } from '@klant/conversational-connector/models/ChatMessage.model';

import { Component, input, output } from '@angular/core';

@Component({
    selector: 'message-choice-option',
    templateUrl: './message-choice-option.component.html',
    standalone: false
})
export class MessageChoiceOptionComponent {
    public choiceOption = input<ChoiceOptionModel>();

    public choiceOptionSelected = output<ChoiceOptionModel>();

    public onSelectOption(): void {
        this.choiceOptionSelected.emit(this.choiceOption());
    }
}
